import { useState, useEffect, useMemo } from 'react';
import 'intersection-observer-polyfill/index.global';
const useInViewport = (
  ref: any,
  considerPartialVisibilityAsNonVisible = false
) => {
  const [inViewport, setInViewport] = useState<null | Boolean>(null);

  const observer = useMemo(() => {
    return new IntersectionObserver(([entry]) => {
      if (!considerPartialVisibilityAsNonVisible) {
        setInViewport(entry.isIntersecting);
      } else {
        const isPartiallyVisible = !!(
          entry.intersectionRatio > 0 && entry.intersectionRatio < 1
        );
        const calculateVisibility = isPartiallyVisible
          ? false
          : entry.isIntersecting;
        setInViewport(calculateVisibility);
      }
    });
  }, [ref]);

  useEffect(() => {
    if (ref?.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return inViewport;
};

export default useInViewport;
